import global from './global.json';
import meta from './meta.json';

import courseGeneral from './pages/course/general.json';
import courseDetails from './pages/course/details.json';
import coursePlaylist from './pages/course/playlist.json';
import courseToolbar from './pages/course/toolbar.json';
import courseSidebar from './pages/course/sidebar.json';
import courseUpsell from './pages/course/upsell.json';
import courseActivityInformation from './pages/course/activity-information.json';
import courseQuiz from './pages/course/quiz.json';
import courseLesson from './pages/course/lesson.json';
import courseComparison from './pages/course/comparison.json';
import courseClaimCertificate from './pages/course/claim-certificate.json';
import courseSummary from './pages/course/summary.json';
import courseRecommendations from './pages/course/recommendations.json';
import courseFeedback from './pages/course/feedback.json';
import courseRelatedContent from './pages/course/related-content.json';
import courseFreeCme from './pages/course/free-cme.json';

export default defineI18nLocale(() => ({
  global,
  meta,

  /*
   * course
   */
  'course': {
    'general': courseGeneral,
    'details': courseDetails,
    'playlist': coursePlaylist,
    'sidebar': courseSidebar,
    'toolbar': courseToolbar,
    'upsell': courseUpsell,
    'activityInformation': courseActivityInformation,
    'quiz': courseQuiz,
    'lesson': courseLesson,
    'comparison': courseComparison,
    'claimCertificate': courseClaimCertificate,
    'summary': courseSummary,
    'recommendations': courseRecommendations,
    'feedback': courseFeedback,
    'relatedContent': courseRelatedContent,
    'freeCme': courseFreeCme,
  },
}));